import React, { useMemo } from "react";
import { FiMaximize2, FiMinimize2 } from "react-icons/fi";

const BlogReadingThemePicker = ({
  themes,
  selectedThemeId,
  onThemeChange,
  isTheaterMode = false,
  onTheaterModeChange,
}) => {
  const groupedThemes = useMemo(
    () => ({
      light: themes.filter((theme) => theme.mode === "light"),
      dark: themes.filter((theme) => theme.mode === "dark"),
    }),
    [themes],
  );

  const renderGroup = (mode, label) => (
    <div className="blog-reading-theme-picker__group">
      <span className="blog-reading-theme-picker__group-label">{label}</span>
      <div className="blog-reading-theme-picker__swatches">
        {groupedThemes[mode].map((theme) => {
          const isActive = selectedThemeId === theme.id;

          return (
            <button
              type="button"
              className={`blog-reading-theme-picker__swatch ${
                isActive ? "blog-reading-theme-picker__swatch--active" : ""
              }`}
              style={{
                "--swatch-bg": theme.background,
                "--swatch-text": theme.text,
                "--swatch-border": theme.border,
              }}
              onClick={() => onThemeChange(theme.id)}
              aria-label={`Use ${theme.label} reading theme`}
              aria-pressed={isActive}
              title={theme.label}
              key={theme.id}
            >
              <span
                className="blog-reading-theme-picker__swatch-preview"
                aria-hidden="true"
              />
            </button>
          );
        })}
      </div>
    </div>
  );

  return (
    <section
      className="blog-reading-theme-picker"
      aria-labelledby="blog-reading-theme-picker-title"
    >
      <div className="blog-reading-theme-picker__header">
        <div
          className="blog-reading-theme-picker__title"
          id="blog-reading-theme-picker-title"
        >
          Reading Theme
        </div>
        {onTheaterModeChange && (
          <button
            type="button"
            className="blog-reading-theme-picker__theater-button"
            onClick={() => onTheaterModeChange(!isTheaterMode)}
            aria-pressed={isTheaterMode}
          >
            {isTheaterMode ? (
              <FiMinimize2 aria-hidden="true" />
            ) : (
              <FiMaximize2 aria-hidden="true" />
            )}
            <span>{isTheaterMode ? "Compact mode" : "Theater mode"}</span>
          </button>
        )}
      </div>
      <div className="blog-reading-theme-picker__groups">
        {renderGroup("light", "Light")}
        {renderGroup("dark", "Dark")}
      </div>
    </section>
  );
};

export default BlogReadingThemePicker;
